export default `{
  quote,
  source,
  ...
}`;
